// Services
import SearchParamsService from "../../search/services/SearchParamsService";
import SearchService from "../../search/services/SearchService";

export const namespaced = true;

export const state = {
  closeHoverPopup: true,
  destinationState: {
    destinationId: NaN,
    display: false
  },
  hoverActiveDestination: {},
  searchParams: SearchParamsService.getSearchParams(),
  searchLoading: true,
  searchDestinations: SearchService.getEmptySearchDestinations(),
  searchPosts: SearchService.getEmptySearchPosts()
};
export const mutations = {
  SET_CLOSE_HOVER_POPUP_TO_TRUE(state) {
    state.closeHoverPopup = true;
  },
  SET_CLOSE_HOVER_POPUP_TO_FALSE(state) {
    state.closeHoverPopup = false;
  },
  SET_DESTINATION_STATE(state, newState) {
    state.destinationState.display = newState.destinationDisplay;
    state.destinationState.destinationId = newState.destinationId;
  },
  SET_HOVER_ACTIVE_DESTINATION(state, destination) {
    state.hoverActiveDestination = destination;
  },
  SET_SEARCH_PARAMS(state, searchParams) {
    state.searchParams = searchParams;
  },
  SET_SEARCH_LOADING(state, boolean) {
    state.searchLoading = boolean;
  },
  SET_SEARCH_DESTINATIONS(state, searchDestinations) {
    state.searchDestinations = searchDestinations;
  },
  SET_SEARCH_POSTS(state, searchPosts) {
    state.searchPosts = searchPosts;
  }
};
export const actions = {
  setCloseHoverPopUpToTrue({ commit }) {
    commit("SET_CLOSE_HOVER_POPUP_TO_TRUE");
  },
  setCloseHoverPopUpToFalse({ commit }) {
    commit("SET_CLOSE_HOVER_POPUP_TO_FALSE");
  },
  setHoverActiveDestination({ commit }, destination) {
    commit("SET_HOVER_ACTIVE_DESTINATION", destination);
  },
  setSearchState({ commit }, state) {
    commit("SET_DESTINATION_STATE", state);
  },
  setSearchParams({ commit }, search) {
    const searchParams = SearchParamsService.newSearchParamsFromUrl(
      search.query,
      search.username
    );
    commit("SET_SEARCH_PARAMS", searchParams);
  },
  setSearchDestinations({ commit, state }) {
    commit("SET_SEARCH_LOADING", true);
    SearchService.getSearchDestinations(state.searchParams)
      .then(searchDestinations =>
        commit("SET_SEARCH_DESTINATIONS", searchDestinations)
      )
      .catch()
      .finally(() => {
        commit("SET_SEARCH_LOADING", false);
      });
  },
  setSearchPosts({ commit, state }) {
    commit("SET_SEARCH_LOADING", true);
    SearchService.getSearchPosts(state.searchParams)
      .then(searchPosts => commit("SET_SEARCH_POSTS", searchPosts))
      .catch()
      .finally(() => {
        commit("SET_SEARCH_LOADING", false);
      });
  },
  resetSearch({ commit }) {
    commit("SET_SEARCH_LOADING", true);
    commit(
      "SET_SEARCH_DESTINATIONS",
      SearchService.getEmptySearchDestinations()
    );
    commit("SET_DESTINATION_STATE", {
      destinationDisplay: false,
      destinationId: NaN
    });
  }
};
export const getters = {
  destinationDisplayed: state => {
    if (
      Number.isInteger(state.destinationState.destinationId) &&
      !isNaN(state.destinationState.destinationId)
    ) {
      for (let i = 0; i < state.searchDestinations.destinations.length; i++) {
        if (
          state.searchDestinations.destinations[i].id ===
          state.destinationState.destinationId
        ) {
          return state.searchDestinations.destinations[i];
        }
      }
    }
    return {};
  }
};
